<app-modal-header title="Change avatar" />

<app-modal-body>
  @if (error()) {
    <p class="form-error" role="alert">{{ error() }}</p>
  }

  <div class="avatar-upload">
    <div class="avatar-upload__preview">
      @if (previewUrl(); as url) {
        <img [src]="url" class="avatar-upload__img" alt="New avatar preview" />
      } @else {
        <div class="sidebar__avatar avatar-upload__placeholder" aria-hidden="true">{{ initials(data().name) }}</div>
      }
    </div>
    <div class="avatar-upload__right">
      <p class="avatar-upload__hint">Upload a photo. JPG, PNG or GIF, max 5 MB.</p>
      <label class="btn--secondary avatar-upload__btn" data-modal-autofocus tabindex="0" (keydown.enter)="fileInput.click()" (keydown.space)="$event.preventDefault(); fileInput.click()">
        Choose file
        <input #fileInput type="file" accept="image/*" hidden (change)="onFileChange($event)" />
      </label>
      @if (file(); as f) {
        <span class="avatar-upload__filename">{{ f.name }}</span>
      }
    </div>
  </div>
</app-modal-body>

<app-modal-footer>
  <button type="button" class="btn--secondary" [disabled]="saving()" (click)="modalRef.dismiss()">Cancel</button>
  <button type="button" class="btn--primary" [disabled]="saving()" (click)="save()">
    {{ saving() ? 'Saving…' : 'Save avatar' }}
  </button>
</app-modal-footer>
